<template>
  <div>
    <Head :title="order.data.id"/>


    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/dergesat">Dërgesat</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ order.data.id }}
      <small v-if="order.data.from_api" class="p-1 text-sm rounded-md bg-gray-400">API</small>
    </h1>


    <danger-flash-message v-if="order.data.is_change" :message="`Kjo dërgesë është ndërrim. Dërgesa e ndërruar: ${order.data.return_id}`"></danger-flash-message>

    <danger-flash-message v-if="order.data.is_cash && order.data.has_product" message="Kjo dërgesë është kthim i mjeteve. Ka produkt për t'u kthyer!"></danger-flash-message>
    <danger-flash-message v-if="order.data.is_cash && !order.data.has_product" message="Kjo dërgesë është kthim i mjeteve."></danger-flash-message>
    <danger-flash-message v-if="order.data.is_cash && order.data.return_id" :message="`Dërgesa për kthim: ${order.data.return_id}`"></danger-flash-message>


    <danger-flash-message v-if="order.data.is_recreated" :message="`Kjo dërgesë është rinisje. Pako duhet të gjindet në depo.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.recreated_id" :message="`Kjo dërgesë është rinisur. ID e dërgesës së re është ${order.data.recreated_id}.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.parent_id" :message="`Kjo dërgesë duhet të bashkohet me dërgesën me ID: ${order.data.parent_id}.`"></danger-flash-message>
    <danger-flash-message v-if="order.data.children_count !== 0" :message="`Kjo dërgesë duhet të bashkohet me ${order.data.children_count} dërgesë(a) tjera.`"></danger-flash-message>
<!--    <danger-flash-message v-if="order.data.money_return" :message="`Është kerkuar t'i kthehen mjetet klientit. Ju mund t'i gjurmoni mjetet duke kërkuar këtë dërgesë në rubrikën 'Kthimet e mjeteve'`"></danger-flash-message>-->




    <div class=" bg-white rounded-md shadow overflow-hidden">

      <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 justify-between -mr-6 p-5">

        <div class="flex flex-wrap mb-4">
          <label class="font-bold">Statusi Aktual: &nbsp;</label>
          <p><span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="statusColor">{{order.data.status}}</span></p>
        </div>
      </div>
    </div>


    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">

        <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">
          <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 -mb-8 p-4">
            <Link v-if="order.data.status_id === 7" class="btn-indigo bg-green-700 text-xs mr-3" :href="`${order.data.id}/rikrijo`">Rinis</Link>

            <button v-if="order.data.status_id !== 5 && order.data.status_id !== 7 && order.data.status_id !== 8" class="btn-indigo bg-blue-700 text-xs mr-3" @click="showBashkimModal = true">Bashkim</button>
            <Teleport to="body">
              <!-- use the modal component, pass in the prop -->
              <modal :show="showBashkimModal" @close="showBashkimModal = false">
                <template #header>
                  <h3>Kjo formë shërben në rastet kur keni për të bashkuar dërgesa nga pika marrëse të ndryshme dhe t'i dërgoni në një destinacion.</h3>
                </template>

                <template #body>

                  <div class="flex flex-wrap">
                    <div class="pb-8 pr-6 w-full lg:w-2/4">
                      <label class="form-label">Pika marrëse:</label>
                      <select v-model="bashkimForm.bashkim_location_id" :error="bashkimForm.errors.bashkim_location_id" class="form-select focus:ring-0 hover:border-indigo-500" >
                        <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.name }}</option>
                      </select>
                    </div>

                    <textarea-input v-model="bashkimForm.bashkim_additional_info" :error="bashkimForm.errors.bashkim_additional_info" class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë (Cka duhet të bashkohet?)" />
                  </div>
                </template>

                <template #footer>
                  <div class="flex flex-wrap">
                    <loading-button class="btn-indigo bg-red-500"
                                    @click = "showBashkimModal = false"
                    >Anulo</loading-button>
                    <loading-button :loading="bashkimForm.processing" class="btn-indigo ml-auto" type="button" @click="bashkimSubmit">Bashko dërgesën</loading-button>
                  </div>
                </template>
              </modal>
            </Teleport>


          </div>

          <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 p-8">
            <Link  v-if=" order.data.status_id === 1"  class="mr-1" :href="`${order.data.id}/edit`" ><icon name="edit" class="mr-2 w-4 h-4"></icon></Link>

            <dropdown class="mr-2 w-4 h-4" placement="bottom-end">
              <template #default>
                <icon name="print" class="mr-2 w-4 h-4"></icon>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.pdf',{order: order.data.id})"  target="_blank">Printo PDF</a>
                  <!-- Only for Pinguiniretail  --><a v-if="user.id === 27" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.pdf',{order: order.data.id, printFull: true})"  target="_blank">Printo PDF(të plotë)</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.sticker.8x5',{order: order.data.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.sticker.10x7',{order: order.data.id})" target="_blank">Printo Stiker 10x7cm</a>
                </div>
              </template>
            </dropdown>


          </div>


        </div>
        <hr>


        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Biznesi</label>
            <p>{{order.data.business_name}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pronari</label>
            <p>{{ order.data.owner_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pika marrëse</label>
            <p>{{ order.data.location }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">ID e sistemit tuaj</label>
            <p>{{ order.data.custom_id }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{ order.data.hr_created_at }}</p>
          </div>
        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Madhësia e pakos</label>
            <p>{{ order.data.package_size }} &nbsp; {{order.data.package_size_description}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pako fragjile</label>
            <p>{{order.data.fragile ? 'Po' : 'Jo'}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Mund te hapet</label>
            <p>{{ order.data.openable ? 'Po' : 'Jo'}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Sasia e produktit</label>
            <p>{{ order.data.quantity }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Produkti</label>
            <p>{{ order.data.product_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pershkrimi</label>
            <p>{{ order.data.product_description }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Çmimi</label>
            <p>{{ order.data.product_price }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Çmimi i postes</label>
            <p>{{order.data.shipping_price}}</p>
          </div>
        </div>

        <hr>
        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Emri & Mbiemri i klientit</label>
            <p>{{ order.data.name }}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Telefoni</label>
            <p>{{ order.data.phone }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Telefoni (sekondar)</label>
            <p>{{ order.data.second_phone }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Shteti</label>
            <p>{{ order.data.country_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Qyteti</label>
            <p>{{ order.data.city_name }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-2/4">
            <label class="font-bold">Adresa</label>
            <p>{{order.data.address}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Fshat/Qytet</label>
            <p class="capitalize">{{order.data.area_type}}</p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Informata shtese</label>
            <p>{{order.data.additional_info}}</p>
          </div>
        </div>

      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden p-5  w-full lg:w-1/2">
        <h1 class="mb-3 text-xl font-bold">Gjurmimi i dërgesës</h1>

        <div class="flex flex-wrap -mb-8 p-8">
          <order-status-timeline :items="orderStatusLogs.data" :barazim="order.data.barazim"></order-status-timeline>
          </div>
        </div>
      </div>
    </div>


    <h1 class="mb-3 text-xl font-bold">Historiku i editimeve</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto ">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Përshkrimi</th>
          <th class="pb-4 pt-6 px-6">Komenti</th>
          <th class="pb-4 pt-6 px-6">Dëshmia</th>
          <th class="pb-4 pt-6 px-6">Edituar nga</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="orderUpdateLog in orderUpdateLogs.data" class="hover:bg-gray-100 focus-within:bg-gray-100">

          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ orderUpdateLog.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4"  tabindex="-1">
              {{ orderUpdateLog.comment }}
            </Link>
          </td>
          <td class="border-t">
              <a v-if="orderUpdateLog.document_path"  class="px-4 py-1 items-center text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: orderUpdateLog.document_path})" download>Shkarko</a>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4"  tabindex="-1">
              <span v-if="orderUpdateLog.impersonated_by">{{ orderUpdateLog.impersonated_by }}
                &nbsp;<icon name="impersonate" class="h-4 inline fill-indigo-600"></icon>&nbsp;
              </span>
              <span>{{ orderUpdateLog.user }}</span>
              <small v-if="orderUpdateLog.from_api" class="mx-0.5 px-2 py-1 rounded-md bg-gray-400">API</small>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4"  tabindex="-1">
              {{ orderUpdateLog.hr_created_at }}
            </Link>
          </td>
        </tr>
        <tr v-if="orderUpdateLogs.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje editim.</td>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import SearchFilter from '@/Shared/SearchFilter'
import Icon from '@/Shared/Icon'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileOutput from '@/Shared/FileOutput'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import OrderStatusTimeline from '@/Shared/OrderStatusTimeline'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    OrderStatusTimeline,
    Icon,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    SearchFilter,
    TrashedMessage,
    FileOutput,
    Modal,
    FileInput,
    DangerFlashMessage,
    Dropdown
  },
  layout: Layout,
  props: {
    order: Object,
    orderUpdateLogs: Object,
    orderStatusLogs: Object,
    orderChange: Object,
    locations: Array
  },
  data(){
    return {
      statusSuccess: this.order.data.status_id === 5,
      statusCancellation: this.order.data.status_id === 7,
      bashkimForm: this.$inertia.form({
        bashkim_location_id: this.order.data.location_id,
        bashkim_additional_info: null
      }),
      moneyReturnForm: this.$inertia.form({
        amount: this.order.data.product_price,
        paid_by_seller: true,
        location_id: this.order.data.location_id,
        description: null
      }),
      showBashkimModal: false,
      showMoneyReturnModal: false,
      location_id_show: true

    }
  },
  methods: {
    bashkimSubmit(){
      this.bashkimForm.post(route('seller.orders.store.merge',{order: this.order.data.id,bashkim_location_id: this.bashkim_location_id,bashkim_additional_info: this.bashkim_additional_info }))
    },
    moneyReturnSubmit(){
      this.moneyReturnForm.post(route('seller.orders.money-return.store',{order: this.order.data.id,amount: this.amount,paid_by_seller: this.paid_by_seller,location_id: this.location_id,description: this.description }))
    },
  },
  watch: {
    'moneyReturnForm.paid_by_seller'(newValue){
      this.location_id_show = newValue
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  computed: {
    statusColor(){
      let color = 'bg-indigo-500'
      if(this.order.data.status_id === 1)
        color = 'bg-yellow-500'

      if(this.order.data.status_id === 3)
        color = 'bg-orange-500'

      if(this.order.data.status_id === 4)
        color = 'bg-indigo-900'

      if(this.order.data.status_id === 5)
        color = 'bg-green-500'

      if(this.order.data.status_id === 6)
        color = 'bg-yellow-700'

      if(this.order.data.status_id === 7)
        color = 'bg-red-500'

      if(this.order.data.status_id === 8)
        color = 'bg-gray-400'

      if(this.order.data.status_id === 9)
        color = 'bg-green-500'

      return color
    }
  },
}
</script>

<style>
</style>
